function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import tasks from '@/js/tasks';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['security']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/security';
var DOMAIN_USER = '/user';
export default {
  loginMicrosoft: function loginMicrosoft(code) {
    var body = {
      code: code
    };

    // tasks.lockScreen.lock(true)
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/login/microsoft"), body, {
      headers: headers
    }).then(function (res) {
      // tasks.lockScreen.unlock()
      // window.apiloginUser = true
      return res.data;
    }).catch(function (err) {
      // tasks.lockScreen.unlock()
      console.error(err);
      // window.apiloginUser = true
      throw err;
    });
  },
  // Acceso sin contraseña: el backend valida la whitelist, genera el enlace
  // (Admin SDK) y lo envía por el correo corporativo. Se llama antes del login,
  // por eso no lleva loginObj.
  sendEmailLink: function sendEmailLink() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/email_link/send"), data, {
      headers: headers
    }).then(function (res) {
      return res.data;
    });
  },
  // Token de corta duracion para identificar al usuario ante una aplicacion
  // externa embebida como iframe. El backend lo firma con el secreto compartido
  // de esa audiencia; aqui solo se transporta.
  getIframeToken: function getIframeToken(audience) {
    var login = loginObj();
    var body = {
      login: login,
      audience: audience
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/iframe_token"), body, {
      headers: headers
    }).then(function (res) {
      return res.data;
    });
  },
  loginUser: function loginUser(email, tokenId, localId) {
    var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // if (window.apiloginUser) return false

    email = email ? email.toLowerCase() : null;
    var login = loginObj(email, tokenId, localId);
    var body = {
      login: login,
      user: user
    };

    // tasks.lockScreen.lock(true)
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/login"), body, {
      headers: headers
    }).then(function (res) {
      // tasks.lockScreen.unlock()
      // window.apiloginUser = true
      return res.data;
    }).catch(function (err) {
      // tasks.lockScreen.unlock()
      console.error(err);
      // window.apiloginUser = true
      throw err;
    });
  },
  loginDetail: function loginDetail(email, tokenId, localId) {
    var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // if (window.apiloginUser) return false

    email = email ? email.toLowerCase() : null;
    var login = loginObj(email, tokenId, localId);
    var body = {
      login: login,
      user: user
    };

    // tasks.lockScreen.lock(true)
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/login_detail"), body, {
      headers: headers
    }).then(function (res) {
      // tasks.lockScreen.unlock()
      // window.apiloginUser = true
      return res.data;
    });
  },
  updateMessagingToken: function updateMessagingToken() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/update_messaging_token"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  getDomainUser: function getDomainUser() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/get_domain"), body).then(function (response) {
      return response.data;
    });
  },
  getDomainRolesUser: function getDomainRolesUser() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/get_roles_domain"), body).then(function (response) {
      return response.data;
    });
  },
  postVerifyEmailRol: function postVerifyEmailRol() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/verify_email_rol"), body).then(function (response) {
      return response.data;
    });
  },
  sendToken: function sendToken() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/token/send_token"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  verifyToken: function verifyToken() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/token/verify_token"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getUserInfo: function getUserInfo() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/get_user_info"), body).then(function (response) {
      return response.data.data;
    });
  },
  deleteUser: function deleteUser() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/delete_user"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get_valid_domains: function get_valid_domains() {
    var login = loginObj();
    var body = {
      login: login
    };
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/get_valid_domains"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  validateEmailDomain: function validateEmailDomain(email) {
    var login = loginObj();
    var body = {
      login: login,
      email: email
    };
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/email/validate-domain/").concat(email), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  migrateRoles: function migrateRoles() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_USER, "/migrate_roles"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      tasks.lockScreen.unlock();
      throw err;
    });
  }
};